module.exports = __webpack_public_path__ + "img/login_bg_new.da738609.png";